import aa from "search-insights";

import "./UserActive.js"
import "./Admin.js"
//import './GlobalSearch.js'
// Index Dashboard
import "./Index.js"
import "./SpendCalc.js"

// Algolia Searches
import "./Algolia.js"
import "./Facilities.js"
import "./Destinations.js"
import "./RightsHolders.js"
import "./Rfps.js"

import Grid from "./Grid.js"
import $ from "jquery";
import "select2"; 


window.makeGrid = function (options) {

    let grid = new Grid(options);
    
    return grid;
};

// Select2
if ($().select2) {
    $('[data-toggle="select2"]').select2();
}

algoliaInsights();

function algoliaInsights() {
    const searchApp = document.querySelector(
        "[data-search-appId]"
    );
    
    if(searchApp == null) return;
    
    const appId = searchApp.getAttribute("data-search-appId");
    const apiKey = searchApp.getAttribute("data-search-apiKey");
    const userToken = searchApp.getAttribute("data-search-userToken");

    aa("init", {
        appId: appId,
        apiKey: apiKey
    });
    aa("setUserToken", userToken);
}